import React from "react";

const Home = () => {
  return (
    <div className="pt-home">
      <div className="addition-bg">
        {/* Fullscreen Slider  */}

        <div className="slide-kenburns-bg">
          <div className="slide-kenburns slide-kenburns-1"></div>
          <div className="slide-kenburns slide-kenburns-2"></div>
          <div className="slide-kenburns slide-kenburns-3"></div>
        </div>
      </div>

      <section>
        {/* Banner  */}
        <div className="banner">
          <h1>Prakash Karena</h1>
          <p className="cd-headline rotate-1">
            <span>I am a </span>
            <span className="cd-words-wrapper">
              <b className="is-visible">Web Developer</b>
              <b>Application Developer</b>
              <b>MERN Stack Developer</b>
            </span>
          </p>
        </div>
        {/* Language 
				            	<div className="lang">
                        <ul>
                          <li><a href="#" className="active">eng</a></li>
                        </ul>
                      </div> */}

        {/* Social */}
        <div className="social">
          <ul>
            <li>
              <a
                target="blank"
                href="https://www.facebook.com/prakash.karena.92"
              >
                <i className="fab fa-facebook-f fa-lg"></i>
              </a>
            </li>
            {/* <li><a href="#"><i className="fab fa-twitter"></i></a></li> */}
            <li>
              <a
                target="blank"
                href="https://www.instagram.com/prakash_r_karena/"
              >
                <i className="fab fa-instagram fa-lg"></i>
              </a>
            </li>
            <li>
              <a
                target="blank"
                href="https://api.whatsapp.com/send?phone=917046207142"
              >
                <i className="fab fa-whatsapp  faa-pulse fa-2x"></i>
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Home;
